export default __webpack_public_path__ + "static/media/03-Saoud-Al-Nuaimi.28c9a2fa.png";